export default __webpack_public_path__ + "6ba793723ff46e84b97f64879212d972.svg";